import React from "react";
import contentfulRichText from "../util/contentfulRichText";

export default ({ answer, question }) => {
    // The text can be either rich text or string
    const text = typeof answer === "string" ?
        <p>{ answer }</p> :
        contentfulRichText(answer);

    return (
        <div className="m-answer">
            <h3 className="m-answer__headline">{ question }</h3>
            { text }
        </div>
    )
}